import Vue from 'vue';
import { ActionTree, MutationTree } from 'vuex';
import { RootState } from '@/store/types';
import { ServerResult } from '@/core/http/server_result';
import moment from 'moment';
import { saveAs } from 'file-saver';

interface MarginalityByProductDetailReportState {
    loaded: boolean;
    loading: boolean;
    fatalError: boolean;

    filter: {
        product_id: any;
        product_container_id: any;
        with_container: any;
        targetDates: Date[];
    };

    data: any[];
    total: any;
}

const state: MarginalityByProductDetailReportState = {
    loading: false,
    loaded: false,
    fatalError: false,

    filter: {
        product_id: null,
        product_container_id: null,
        with_container: null,
        targetDates: [new Date(), new Date()],
    },

    data: [],
    total: {
        clients: 0,
        weight: 0,
        clients_by_product: {}
    },
};

function buildFilter(params: any) {
    const queryParams: any = {}

    if (params.targetDates) {
        queryParams.date_from = moment(params.targetDates[0]).format('YYYY-MM-DD');
        queryParams.date_to = moment(params.targetDates[1]).format('YYYY-MM-DD')
    }
    if (params.product_id) {
        queryParams.product_id = params.product_id;
    }
    if (params.product_container_id) {
        queryParams.product_container_id = params.product_container_id;
    }
    // if (params.with_archived) {
    //     queryParams.with_archived = params.with_archived
    // }

    return queryParams;
}

export const REPORT_DATA = 'REPORT_DATA';

export const actions: ActionTree<MarginalityByProductDetailReportState, RootState> = {

    loadData({ commit, state, dispatch }, params) {
        const vm = (this as any)._vm;

        return new Promise((resolve, reject) => {

            if (Object.values(params).length > 0) {
                commit('START_LOADING');

                vm.$db([
                    vm.$q(REPORT_DATA)
                        .raw('reports.margin_by_product_detail')
                        .action(buildFilter(params)),
                ]).then(((result: ServerResult) => {
                    commit('SET_REPORT_DATA', result.getOperation(REPORT_DATA).getContent());
                    commit('LOADED_SUCCESS');
    
                    resolve();
                }));
            } else {
                resolve();
            }
        })
    },

    exportDataAsXLSX({rootState}, params) {
        const vm = (this as any)._vm;

        return new Promise((resolve, reject) => {
            vm.$db([
                vm.$q('EXPORT')
                .raw('reports.margin_by_product_detail.export')
                .action({ ...buildFilter(params), format: 'xlsx'})
            ]).then(((result: ServerResult) => {
                const exportOpContent = result.getOperation('EXPORT').getContent();
                const fToken = exportOpContent.token;
                const aToken = (rootState as any).ubic.token
                const fileUrl = `${process.env.VUE_APP_UBIC_SERVER_ADDRESS}/api/v1/exports/${fToken}?authorization=${aToken}`;
                saveAs(fileUrl, 'export.xlsx')

                resolve();
            }));
        })
    },


};

export const mutations: MutationTree<MarginalityByProductDetailReportState> = {
    START_LOADING: (state) => {
        state.loaded = false;
        state.loading = true;
        state.fatalError = false;
    },
    LOADED_SUCCESS: (state) => {
        state.loaded = true;
        state.loading = false;
        state.fatalError = false;
    },
    LOADED_ERROR: (state) => {
        state.loaded = true;
        state.loaded = false;
        state.fatalError = true;
    },

    SET_REPORT_DATA(state, {documents, sums, schema}) {
        const clients: any[] = []
        state.total.weight = 0
        state.data = documents.reduce((acc: any[], item: any) => {
            acc.push({
                is_first: true,
                name: item.name,
                container_name: item.container_name,
                clients_count: item.clients.length,
                class_name: 'product-row',
                weight_total: item.clients.reduce((acc: number, client: any) => {
                    acc += parseFloat(client.weight)
                    return acc
                }, 0),
            })
            item.clients.forEach((client: any, idx: number) => {
                if (!clients.includes(client.client_id)){
                    clients.push(client.client_id)
                }
                acc.push({
                    is_first: false,
                    name: item.name,
                    class_name: 'client-row',
                    container_name: item.container_name,
                    client_name: client.client_name,
                    weight: client.weight,
                    clients_count: item.clients.length,
                    weight_total: item.clients.reduce((acc: number, client: any) => {
                        acc += parseFloat(client.weight)
                        return acc
                    }, 0),
                })
                state.total.weight += parseFloat(client.weight)
            })
            return acc
        }, []).sort((a: any, b: any) => {
            const keyA = [a.name, a.container_name].join('-')
            const keyB = [b.name, b.container_name].join('-')
            if (keyA > keyB) {
                return 1
            } else if (keyA < keyB) {
                return -1
            } else {
                return 0
            }
        }).sort((a: any, b: any) => {
            const keyA = parseFloat(a.weight)
            const keyB = parseFloat(b.weight)
            if (a.name == b.name && a.container_name == b.container_name) {
                if (keyA > keyB) {
                    return -1
                } else if (keyA < keyB) {
                    return 1
                } else {
                    return 0
                }
            } else {
                return 0
            }
        }).reduce((acc: any[], item: any) => {
            // if (acc.length) {
            //     const keyA = [item.name, item.container_name].join('-')
            //     const keyB = [acc[acc.length -1].name, acc[acc.length -1].container_name].join('-')
            //     item.is_first = keyA !== keyB
            // } else {
            //     item.is_first = true
            // }
            acc.push(item)
            return acc
        }, []);
        state.total.clients = clients.length;
    },
};

const getters = {

};

export const STORE_KEY = '$_marginality_by_product_detail_report';

export const store = {
    namespaced: true,
    state,
    actions,
    getters,
    mutations,
};
